const StatCard = ({ icon, label, value, gradient, helper }) => (
  <div className="stat-card-hover">
    <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${gradient} flex items-center justify-center text-white text-xl shadow-pop mb-3`}>
      {icon}
    </div>
    <p className="text-xs text-ink-500 dark:text-ink-400 uppercase tracking-wider font-medium">{label}</p>
    <p className="text-2xl font-bold text-ink-900 dark:text-white mt-1">{value}</p>
    {helper && <p className="text-xs text-ink-400 mt-1">{helper}</p>}
  </div>
);

export default StatCard;
